import React from "react";

function rrSubText() {
  return (
    <span className="fs-25 nexaLight ctext-dark m-t-10">
      Incastriamo le coincidenze
    </span>
  );
}

export default rrSubText;
